export default "\r\n<app-service-type-list></app-service-type-list>\r\n\r\n\r\n";